import React from "react";
import RecordsManager from "@/pages/admin/RecordsManager";

export default function Enquiries() {
  return (
    <RecordsManager
      title="Enquiries"
      endpoint="enquiries"
      nameField="name"
      columns={[
        { key: "name", label: "Name" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "service", label: "Service" },
        { key: "preferredDate", label: "Preferred Date" },
      ]}
      detailFields={[
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "age", label: "Age" },
        { key: "service", label: "Service / Reason" },
        { key: "preferredDate", label: "Preferred Date" },
        { key: "preferredTime", label: "Preferred Time" },
        { key: "message", label: "Message" },
      ]}
    />
  );
}
